import { ObjectUtil } from '@/utils/Object'

export const ObjectHelper = {
  ...ObjectUtil
}
